module.exports = __webpack_public_path__ + "static/img/boxdemo.e54d9cd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/boxdemo.png
// module id = x/cr
// module chunks = 1